import { gql } from '@apollo/client';
/**
 * @fragment EntityNoteFragment
 * @since 1.0.0
 */
export const EntityNoteFragment = gql `
  fragment EntityNoteFragment on EntityNote {
    id
    entity
    content
    author {
      id
      fullname
      firstname
      image {
        url
      }
    }
    createdAt
    updatedAt
  }
`;
